import { render, staticRenderFns } from "./MaccordioSubItemAlgoServer.vue?vue&type=template&id=63f58596&scoped=true"
import script from "./MaccordioSubItemAlgoServer.vue?vue&type=script&lang=js"
export * from "./MaccordioSubItemAlgoServer.vue?vue&type=script&lang=js"
import style0 from "./MaccordioSubItemAlgoServer.vue?vue&type=style&index=0&id=63f58596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f58596",
  null
  
)

export default component.exports